var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateEduSuc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ok",
    clipPath: "url(#clip0_16499_7224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.6663 32.4997C58.6663 47.2263 46.7263 59.1663 31.9997 59.1663C17.273 59.1663 5.33301 47.2263 5.33301 32.4997C5.33301 17.773 17.273 5.83301 31.9997 5.83301C46.7263 5.83301 58.6663 17.773 58.6663 32.4997Z",
    fill: "#B8D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.5803 6.3304L25.5439 40.6123L30.9675 45.8388L64.0038 11.5569L58.5803 6.3304Z",
    fill: "#B8D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.1946 13.9893L25.5439 40.6146L30.9666 45.8399L55.6666 20.2026C54.4773 17.9186 52.9666 15.8266 51.1946 13.9893Z",
    fill: "#0E6AF4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.9653 24.8568L14.751 30.292L30.97 45.852L36.1844 40.4168L19.9653 24.8568Z",
    fill: "#0E6AF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16499_7224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateEduSuc);
export default __webpack_public_path__ + "static/media/update_edu_suc.11877a4234ff269893710073356999d4.svg";
export { ForwardRef as ReactComponent };